<template>
  <div class="echarts-container" ref="chart"></div>
</template>

<script>
import * as echarts from 'echarts';
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

export default {
  props: ['data'],
  mounted() {
    this.initChart(this.data);
  },
  watch: {
    data: {
      immediate: true, // Trigger the watch immediately on mount
      handler(newData) {
        this.initChart(newData);
      },
    },
  },
  methods: {
    initChart(data) {
      console.log("props",data.perPharmacyEarnings)
      const isAustralia = isAustraliaRegion().value;
      console.log("🚀 ~ initChart ~ isAustralia:", isAustralia)
      let pharmacyNames = data.perPharmacyEarnings.map((pharmacy) => pharmacy.name);
      console.log("name of ph",pharmacyNames );
      let totalAmount = data.perPharmacyEarnings.map((pharmacy) => pharmacy.total.totalAmount);
      let totalGst = data.perPharmacyEarnings.map((pharmacy) => pharmacy.total.totalGst);
      let totalTravelCompensation = data.perPharmacyEarnings.map(
        (pharmacy) => pharmacy.total.totalTravelCompensation
      );
      let totalSuperAmount= 0;
      if(isAustralia.value){
        totalSuperAmount = data.perPharmacyEarnings.map(
        (pharmacy) => pharmacy.total.totalSuperAmount
      );
      }
 
      const option = {
        title: {
          text: '',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          valueFormatter: (value) => value,
        },
        xAxis: {
          type: 'category',
          data: pharmacyNames,
          axisLabel: {
            show: false, // Hide the x-axis label
            // You can add other axisLabel properties here if needed
          },
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: 'Net Amount',
            data: totalAmount,
            type: 'bar',
            stack: 'stacked',
          },
          {
            name: 'Total GST',
            data: totalGst,
            type: 'bar',
            stack: 'stacked',
          },
          {
            name: 'Total Travel Compensation',
            data: totalTravelCompensation,
            type: 'bar',
            stack: 'stacked',
          },
          ...(isAustralia ? [{
            name: 'Total Super Amount',
            data: totalSuperAmount,
            type: 'bar',
            stack: 'stacked',
          }] : []),
          // Add more series as needed
        ],
      };

      const chart = echarts.init(this.$refs.chart);
      chart.setOption(option);
    },
  },
};
</script>

<style>
.echarts-container {
  width: 100%;
  height: 400px;
}
</style>
